module.exports = __webpack_public_path__ + "img/login_logo.ec6c2903.png";